<template>
<div class="chapter">
<div class="inner_page">
<div id="a01_uthor">
<p class="para">ARTHUR J MARDER was a meticulous researcher, teacher and writer who, born in 1910, was to become perhaps the most distinguished historian of the modern Royal Navy. He held a number of teaching posts in American universities and was to receive countless honours, as well as publish some fifteen major works on British naval history. He died in 1980.</p>
<p class="para1">BARRY GOUGH, the distinguished Canadian maritime and naval historian, is the author of <i>Historical Dreadnoughts: Arthur Marder, Stephen Roskill and the Battles for Naval History</i>, recently published by Seaforth Publishing.</p>
<p class="img"><img alt="image" src="images/p0-1.jpg"/></p>
<p class="fgcaption"><a id="uthf1"></a>ADMIRAL SIR JOHN JELLICOE</p>
<p class="fgcaptiona">Commander-in-Chief, Grand Fleet, 1914–16</p>
<p class="fgcaptionb"><i>[Photograph : Radio Times Hulton Picture Library</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_uthor.vue?0ba01ada